import { render, staticRenderFns } from "./GameVersions.vue?vue&type=template&id=5471bfeb&"
import script from "./GameVersions.vue?vue&type=script&lang=js&"
export * from "./GameVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports